module.exports = __webpack_public_path__ + "static/media/k12_site_about_header.3ae1f286.jpg";